import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, AnimatePresence } from "framer-motion";

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const dotX = useSpring(x, { stiffness: 900, damping: 50 });
  const dotY = useSpring(y, { stiffness: 900, damping: 50 });
  const ringX = useSpring(x, { stiffness: 220, damping: 24, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 220, damping: 24, mass: 0.6 });
  const [hovering, setHovering] = useState(false);
  const [label, setLabel] = useState("");
  const [fine, setFine] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(pointer: fine)");
    setFine(mq.matches);
    if (!mq.matches) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const t = e.target;
      const tagged = t.closest && t.closest("[data-cursor]");
      setLabel(tagged ? tagged.dataset.cursor : "");
      setHovering(!!(t.closest && t.closest("a, button, input, select, textarea, [role=button]")));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!fine) return null;

  return (
    <>
      <motion.div
        className="pointer-events-none fixed z-[99] h-2 w-2 rounded-full bg-[#B68D40]"
        style={{ x: dotX, y: dotY, translateX: "-50%", translateY: "-50%" }}
        animate={{ opacity: label ? 0 : 1, scale: hovering ? 0.5 : 1 }}
        transition={{ duration: 0.2 }}
      />
      <motion.div
        className={`pointer-events-none fixed z-[99] flex items-center justify-center rounded-full ${
          label ? "bg-[#B68D40] shadow-[0_8px_32px_rgba(182,141,64,0.45)]" : "border border-[#B68D40]/60"
        }`}
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: label ? 88 : hovering ? 56 : 34,
          height: label ? 88 : hovering ? 56 : 34,
          opacity: label ? 1 : hovering ? 0.9 : 0.5,
        }}
        transition={{ type: "spring", stiffness: 300, damping: 22 }}
      >
        <AnimatePresence>
          {label && (
            <motion.span
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.6 }}
              className="font-num text-[10px] font-semibold uppercase tracking-[0.2em] text-[#1B1B1B]"
            >
              {label}
            </motion.span>
          )}
        </AnimatePresence>
      </motion.div>
    </>
  );
}
